import { render, staticRenderFns } from "./Maintabbaruser.vue?vue&type=template&id=8ff51678&scoped=true&"
import script from "./Maintabbaruser.vue?vue&type=script&lang=js&"
export * from "./Maintabbaruser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ff51678",
  null
  
)

export default component.exports